export default {"src":"/_next/static/media/fail.ec483be4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};